import { BsEye, BsFileEarmarkArrowDown, BsPencil, BsTrash } from "react-icons/bs"
import { FunctionComponent, h } from "preact"

import AddNCR from "./add-ncr"
import { BiMapPin } from "react-icons/bi"
import { Button } from "../../../parts/buttons"
import Container from "../../../parts/container"
import NCRDetails from "./details-ncr"
import { Role } from "../../../enum/roles.enum"
import TopBar from "../../../components/topbar"
import TopFilter from "../../../components/TopFilter"
import UserRoles from "./user-roles"
import useAllNCR from "../../../hooks/useAllNCR"
import useAuth from "../../../hooks/useAuth"
import { useConfirm } from "../../../context/useConfirm"
import { useEffect } from "preact/hooks"
import useMills from "../../../hooks/useMills"
import useModal from "../../../hooks/useModal"
import useObjectState from "../../../hooks/useObjectState"
import useTopFilter from "../../../hooks/useTopFilter"

type NCRListPageProps = h.JSX.HTMLAttributes<HTMLDivElement>

const NCRListPage: FunctionComponent<NCRListPageProps> = () => {
  enum Page {
    Edit,
    List,
    Details,
  }
  const filter = useTopFilter()
  const confirmation = useConfirm()
  const { data: ncr, mutate } = useAllNCR(filter.output)

  console.log(ncr)
  // ncr?.map()
  // console.log(ncr[0].ncr_status_history[0])
  const [selected, setSelected] = useObjectState({
    mil: "",
    role: Role.Member,
    page: Page.List,
    uuid: "",
    edit_at: 0,
  })
  const { show, onHide, onShow } = useModal()
  const { data: mills } = useMills()
  const { isLogin, fetcher } = useAuth()
  const approve = useModal()

  const onBack = () => {
    setSelected({ page: Page.List, uuid: "", edit_at: new Date().getTime() })
    approve.onHide()
    setApprovalBody({ reason: "" })
    onHide()
    mutate()
  }
  const [approvalBody, setApprovalBody] = useObjectState({
    status: "Approve",
    reason: "",
    type: 0,
  })

  useEffect(() => {
    isLogin().then((u) => {
      if (u) setSelected({ role: u.role })
    })
  }, [])

  const handleDelete = (uuid: string) => {
    confirmation(
      "Are you sure you want to delete it?",
      (isDelete) => {
        if (isDelete)
          fetcher()
            .delete("/ncr/" + uuid)
            .then(() => {
              onBack()
            })
            .catch(console.error)
      },
      { yes: "Delete", no: "Cancel" }
    )
  }

  const handleSubmit = () => {
    fetcher()
      .put(`/ncr/${approvalBody.type == 3 ? "validation" : "approval"}/${selected.uuid}`, approvalBody)
      .then(() => onBack())
  }

  if (selected.page == Page.Edit) return <AddNCR uuid={selected.uuid} onBack={onBack} />
  if (selected.page == Page.Details) return <NCRDetails uuid={selected.uuid} onBack={onBack} />
  return (
    <div>
      {/* modal */}
      <form
        className="modal-backdrop"
        style={{
          display: approve.show ? "inherit" : "none",
          backgroundColor: "#00000099",
          overflowY: "auto",
        }}
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
          <div class="modal-content card">
            <div className="card-body text-center h5">Approval</div>
            <div className="card-body">
              <select
                value={approvalBody.status}
                onChange={({ currentTarget: e }) => setApprovalBody({ status: e.value })}
                required
                className="form-control text-center rounded-pill"
              >
                <option value="Approve">APPROVE</option>
                <option value="Reject">REJECT</option>
              </select>
              <div className="my-3">
                <textarea
                  className="form-control"
                  type="text"
                  required
                  placeholder="Isi dengan alasan Approval"
                  value={approvalBody.reason}
                  onChange={({ currentTarget: e }) => setApprovalBody({ reason: e.value })}
                />
              </div>
            </div>
            <div className="card-body d-flex justify-content-center">
              <Button onClick={approve.onHide} type="button" variant="tertiary" className="m-1">
                Cancel
              </Button>
              <Button variant="primary" type="submit" className="m-1">
                Select
              </Button>
            </div>
          </div>
        </div>
      </form>
      {/* end-modal */}
      <UserRoles show={show} onHide={onHide} />
      <TopBar title="SPARING" subtitle="NCR">
        <TopFilter hook={filter} />
      </TopBar>
      <Container>
        <div className="card">
          <div className="card-body">
            <div className="d-flex flex-row justify-content-between align-items-end">
              <div className="">
                <h3>NCR</h3>
                <div className="">
                  Level: <span className="text-primary">{selected.role}</span>
                  <br />
                  <br />
                  <select
                    value={selected.mil}
                    onChange={({ currentTarget: e }) => setSelected({ mil: e.value })}
                    className="w-auto form-select rounded-pill"
                  >
                    <option value="">All Mills</option>
                    {mills?.map(({ uuid, name }) => (
                      <option value={uuid} key={uuid}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="">
                <Button variant="primary" className="ms-2" onClick={() => setSelected({ page: Page.Edit })}>
                  ADD NEW ENTRY
                </Button>
                <Button variant="primary" className="ms-2" onClick={onShow}>
                  SEE ROLES DESCRIPTION
                </Button>
                <Button variant="primary" className="ms-2 d-none" icon={BsFileEarmarkArrowDown}>
                  EXPORT
                </Button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <table className="table table-striped table-center">
              <thead>
                <tr>
                  <th>LK Number</th>
                  <th>Date</th>
                  <th>Mill/Unit</th>
                  <th>Creater</th>
                  <th>First Approval</th>
                  <th>Second Approval</th>
                  <th>Validation Status</th>
                  <th colSpan={2}>Menu</th>
                </tr>
              </thead>
              <tbody>
                {ncr
                  ?.filter(({ mil }) => !selected.mil || mil.uuid == selected.mil)
                  .map((n) => (
                    <tr key={n.uuid}>
                      <td>{n.lk_number}</td>
                      <td>{n.date}</td>
                      <td>{n.mil.name}</td>
                      {/* {n.ncr_status_history.map((v) => (
                            <td>{v.created_by.name}</td>
                          ))} 
                      */}
                      <td> 
                      {
                        n.ncr_status_history.length==1 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[0].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[0].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[0].status}</li>
                        </ul>
                        :
                        n.ncr_status_history.length==2 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[1].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[1].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[1].status}</li>
                        </ul>
                        :
                        n.ncr_status_history.length==3 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[2].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[2].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[2].status}</li>
                        </ul>
                        :
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[3].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[3].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[3].status}</li>
                        </ul>
                        }
                        
                      </td>
                      <td>
                        
                        {
                        n.ncr_status_history.length==2 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[0].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[0].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[0].status}</li>
                        </ul>
                        :
                        n.ncr_status_history.length==3 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[1].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[1].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[1].status}</li>
                        </ul>
                        :
                        n.ncr_status_history.length==4 ?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[2].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[2].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[2].status}</li>
                        </ul>
                        :
                        n.first_approval
                        }
                        </td>
                      <td>
                        {
                        n.ncr_status_history.length==3?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[0].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[0].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[0].status}</li>
                        </ul>
                        :
                        n.ncr_status_history.length==4?
                        <ul style={"text-align:left"}>
                          <li>Name : {n.ncr_status_history[1].created_by.name}</li>
                          <li>Role : {n.ncr_status_history[1].created_by.role}</li>
                          <li>Status : {n.ncr_status_history[1].status}</li>
                        </ul>

                        :n.second_approval
                        }
                      </td>
                      <td>{n.validator}</td>
                      <td>
                        <Button
                          className="me-2"
                          variant="primary"
                          icon={BsEye}
                          onClick={() => setSelected({ uuid: n.uuid, page: Page.Details })}
                        />
                        <Button
                          className="me-2"
                          variant="secondary"
                          icon={BsPencil}
                          onClick={() =>
                            setSelected({
                              uuid: n.uuid,
                              page: Page.Edit,
                              edit_at: new Date().getTime(),
                            })
                          }
                        />
                        <Button
                          className="me-2"
                          variant="tertiary"
                          icon={BsTrash}
                          onClick={() => handleDelete(n.uuid)}
                        />
                      </td>
                      <td>
                        <Button
                          variant="secondary"
                          icon={BiMapPin}
                          onClick={() => {
                            setSelected({ uuid: n.uuid })
                            setApprovalBody({
                              type:
                                selected.role !== Role.SustainabilityDiv ? (n.first_approval == "Approve" ? 2 : 1) : 3,
                            })
                            approve.onShow()
                          }}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default NCRListPage
